import type { AccessibleTenant, ConnectorDto, MeResponse } from '@atnt/shared';
import { registryRights } from '@/features/devices/permissions';

/** Organization admins (and the platform admin) own organization connectors and the tenant's integration fields. */
export const isOrgAdminOf = (me: MeResponse, tenant: AccessibleTenant) =>
  me.isPlatformAdmin || me.organizations.some((o) => o.id === tenant.organizationId && o.isAdmin);

export interface ConnectorRights {
  read: boolean;
  create: boolean;
  /** may create / edit / delete organization connectors and edit the unified-server site code */
  orgAdmin: boolean;
  /** test connections, bind source sensors, map channels, import (tenant-level work, any scope) */
  operate: boolean;
  canEdit: (c: Pick<ConnectorDto, 'scope'>) => boolean;
  canDelete: (c: Pick<ConnectorDto, 'scope'>) => boolean;
}

/** Admin module `connectors` CRUD (registryRights) + the organization-admin rule for organization-scope connectors. */
export function connectorRights(tenant: AccessibleTenant, me: MeResponse): ConnectorRights {
  const crud = registryRights(tenant.permissions).connectors;
  const orgAdmin = isOrgAdminOf(me, tenant);
  return {
    read: crud.read,
    create: crud.create,
    orgAdmin,
    operate: crud.update,
    canEdit: (c) => crud.update && (c.scope === 'tenant' || orgAdmin),
    canDelete: (c) => crud.delete && (c.scope === 'tenant' || orgAdmin),
  };
}
